/* ============================================================
   BMN VAT toggle (display only)
   - Persists the visitor's choice in localStorage ('bmn-vat-mode').
   - Default = inc-VAT. When 'ex' is chosen, html.vat-mode-ex is set
     and CSS swaps every .vat-inc / .vat-ex span.
   - Injects the sliding switch into the dark utility bar
     (.bmn-util__right) so sections/header.liquid needs no editing.
   The critical show/hide CSS + the pre-paint class are set inline in
   snippets/meta-tags.liquid to avoid any flash of both prices.
   ============================================================ */
(function () {
  var KEY = 'bmn-vat-mode';
  var docEl = document.documentElement;

  function getMode() {
    try {
      return localStorage.getItem(KEY) === 'ex' ? 'ex' : 'inc';
    } catch (e) {
      return 'inc';
    }
  }

  function syncButtons(mode) {
    var btns = document.querySelectorAll('.vat-toggle__btn');
    for (var i = 0; i < btns.length; i++) {
      var active = btns[i].getAttribute('data-vat-mode') === mode;
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function apply(mode) {
    if (mode === 'ex') {
      docEl.classList.add('vat-mode-ex');
    } else {
      docEl.classList.remove('vat-mode-ex');
    }
    syncButtons(mode);
  }

  function setMode(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    apply(mode);
  }

  function buildToggle() {
    var wrap = document.createElement('div');
    wrap.className = 'vat-toggle';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Show prices including or excluding VAT');
    wrap.innerHTML =
      '<span class="vat-toggle__label">Prices</span>' +
      '<div class="vat-toggle__group">' +
        '<span class="vat-toggle__thumb" aria-hidden="true"></span>' +
        '<button type="button" class="vat-toggle__btn" data-vat-mode="inc" aria-pressed="true">Inc VAT</button>' +
        '<button type="button" class="vat-toggle__btn" data-vat-mode="ex" aria-pressed="false">Ex VAT</button>' +
      '</div>';
    return wrap;
  }

  function injectToggle() {
    if (document.querySelector('.vat-toggle')) return;
    var host = document.querySelector('.bmn-util__right');
    if (!host) return;
    var toggle = buildToggle();
    var firstPill = host.querySelector('.bmn-util__pill');
    if (firstPill) {
      host.insertBefore(toggle, firstPill);
    } else {
      host.appendChild(toggle);
    }
  }

  function init() {
    injectToggle();
    apply(getMode());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.vat-toggle__btn') : null;
    if (!btn) return;
    setMode(btn.getAttribute('data-vat-mode'));
  });
})();
